export const GA_MEASUREMENT_ID = "G-BMC62C2R22";

export function isAnalyticsAvailable() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

function buildPageViewParams() {
  return {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search + window.location.hash,
  };
}

// The Google tag (gtag.js) is deliberately set up on `window`'s `load`
// event (see public/index.html) to keep it off the critical rendering
// path. React can mount — and AnalyticsTracker can call trackPageView()
// — well before that `load` event fires, which would otherwise drop the
// page view entirely since `window.gtag` doesn't exist yet. Queue just
// the latest pending page view and flush it once `load` fires (index.html's
// own `load` listener always runs first and defines `window.gtag`
// synchronously, so by the time this listener runs it's either ready, or
// permanently disabled via `exclude_mobile` — in which case we simply
// never flush, same as today).
let pendingPageView = null;
let loadListenerRegistered = false;

// True once AnalyticsTracker.jsx has confirmed (post auth-resolve) that the
// current visitor is a logged-in admin. While true, GA4 never initialises
// in index.html (see `window.__gaSetAdminStatus`) and every function below
// becomes a hard no-op — including discarding a page view that was queued
// before admin status was known, so a delayed GA4 init can never flush it.
let adminExcluded = false;

export function setAdminExcluded(isAdmin) {
  adminExcluded = !!isAdmin;
  if (adminExcluded) {
    pendingPageView = null;
  }
  if (typeof window !== "undefined" && typeof window.__gaSetAdminStatus === "function") {
    window.__gaSetAdminStatus(adminExcluded);
  }
}

function flushPendingPageView() {
  if (pendingPageView && !adminExcluded && isAnalyticsAvailable()) {
    window.gtag("event", "page_view", pendingPageView);
  }
  pendingPageView = null;
}

export function trackPageView() {
  if (adminExcluded) return;

  if (isAnalyticsAvailable()) {
    window.gtag("event", "page_view", buildPageViewParams());
    return;
  }

  pendingPageView = buildPageViewParams();
  if (!loadListenerRegistered && typeof window !== "undefined") {
    loadListenerRegistered = true;
    window.addEventListener("load", flushPendingPageView);
  }
}

export function trackEvent(name, parameters = {}) {
  if (adminExcluded) return;
  if (!isAnalyticsAvailable()) return;
  window.gtag("event", name, parameters);
}
